import { AuthService } from '@/services/auth.service'

export default {
  namespaced: true,
  state: {
    accessTokenExpDate: '',
    token: ''
  },
  actions: {
    logout ({ commit }) {
      commit('LOGOUT')
    }
  },
  mutations: {
    SET_ATOKEN_EXP_DATE (state, expDate) {
      state.accessTokenExpDate = expDate
    },
    SET_TOKEN (state, token) {
      state.token = token
    },
    LOGOUT (state) {
      state.user = null
      state.token = null
      AuthService.removeLocalStorage('idUserData')
      AuthService.removeCookie('TID', process.env.VUE_APP_COOKIE_DOMAIN)
      window.location.href = '/'
    }
  }
}
